import { locatorServiceAPI } from 'shared/services';

import {
  Report,
  CreateReportForm,
  ReportGuid
} from './types';

export const reportsAPI = {
  createReport: (form: CreateReportForm) => locatorServiceAPI.post<{ reportGuid: ReportGuid }>('reports/uiStationList', form),
  getReports: () => locatorServiceAPI.get<{ reports: Report[] }>('reports/list'),
  getReport: (reportGuid: ReportGuid) => locatorServiceAPI.get<Blob>(`reports/download/${reportGuid}`, { responseType: 'blob' })
};
